import React from 'react';

export default () => (
  <div className="lp-footer">
    <div className="lp-footer-txt">© Telepat North 2020</div>
  </div>
);
